import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-app-logs-details-dialog',
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatCardModule,
        MatListModule,
        CommonModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatIconModule
    ],
    templateUrl: './details.component.html',
    styleUrl: './details.component.scss'
})
export class AppLogDetailsDialogComponent {
    appLogDetails: any = {};

    constructor(public dialogRef: MatDialogRef<AppLogDetailsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.appLogDetails = data.appLogDetails;
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
